import styled from 'styled-components';

import alert from '../../../assets/alert.svg';
import colors from '../../../styles/colors';

export const Container = styled.div`
  span {
    color: #c11e1e;
  }
  span:before {
    content: url(${alert});
    padding: 0 10px 0 0;
    vertical-align: -10%;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 48px;
  width: 100%;
  border-radius: 5px;
  border: 1px solid #e6e6e6;
  margin-bottom: 5px;

  &:focus-within {
    border: solid 1px ${colors.darkgray};
  }

  input {
    width: 90%;
    height: 90%;
    border: none;
    padding: 0 16px;
    transition: border 0.3s;
    &::placeholder {
      color: ${colors.gray};
    }
    &:disabled {
      background: #f2f2f2;
    }
  }
`;

export const Optional = styled.small`
  color: #4d4d4d;
  font-size: 14px;
`;

export const Label = styled.label`
  font-weight: normal !important;
`;

export const Box = styled.div`
  margin: 10px 0 5px 0;
`;
